module.exports = __webpack_public_path__ + "./fonts/new_logo.f4d87a1cdd5eaa1fffe6f73d51052c13.svg";